import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { asyncScheduler, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppState } from './../../../store/app-reducers';

@Component({
  selector: 'app-new-section-game',
  templateUrl: './new-section-game.page.html',
  styleUrls: ['./new-section-game.page.scss'],
})
export class NewSectionGamePage implements OnInit, AfterViewInit, OnDestroy {

  public heart = false;
  public MenuHeader: Observable<boolean>;

  constructor(
    private modalCtrl: ModalController
    , private store: Store<AppState>
  ) {
    this.MenuHeader = this.store.select('userData').pipe(map(mh => mh.MenuHeader.filter(m => m.tab === 'juegos')), map(mh => mh.length > 0 && mh[0].active));
  }

  ngOnInit() {
    asyncScheduler.schedule(() => this.heart = true, 100);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  public onClose = (event: boolean) => this.modalCtrl.dismiss(event);

}
